import {AfterViewInit, Directive, ElementRef, HostListener, OnDestroy, Renderer2} from '@angular/core';

@Directive({
  selector: '[appScrollTopBottom]'
})
export class ScrollTopBottomDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.checkIfScrollable();
    this.checkScroll();

    this.observer = new MutationObserver(() => {
      this.checkIfScrollable();
      this.checkScroll();
    });
    this.observer.observe(this.el.nativeElement, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private checkIfScrollable() {
    const element = this.el.nativeElement;

    if (element.scrollHeight > element.clientHeight) {
      element.classList.add('is-scrollable');
      element.classList.remove('not-scrollable');
    } else {
      element.classList.add('not-scrollable');
      element.classList.remove('is-scrollable');
    }
  }

  @HostListener('scroll')
  private checkScroll() {
    const element = this.el.nativeElement;
    const isAtBottom = Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 2;
    const isAtTop = element.scrollTop === 0;

    if (isAtBottom) {
      this.renderer.addClass(element, 'scroll-bottom');
    } else {
      this.renderer.removeClass(element, 'scroll-bottom');
    }

    if (isAtTop) {
      this.renderer.addClass(element, 'scroll-top');
    } else {
      this.renderer.removeClass(element, 'scroll-top');
    }
  }

}
